import { getProducts } from "./getProductsConfig";

export const externalConfigService = {
  getProducts,
}